function prepareFile(file: Blob): FormData {
  const form = new FormData();
  form.append('file', file);
  return form;
}

export { prepareFile };
